import { render, staticRenderFns } from "./BagianLuarCard.vue?vue&type=template&id=1798702e&"
import script from "./BagianLuarCard.vue?vue&type=script&lang=js&"
export * from "./BagianLuarCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports